import React, { useEffect, useRef, useState } from 'react';
import * as Tone from 'tone';
import KeyboardExample from './KeyboardExample';

const baseUrl = 'https://sheet-music-rl.onrender.com'

// Keyboard layout: includes accidentals using QWERTY-style pattern
const KEY_NOTE_MAP = {
  a: 'C4',
  w: 'C#4',
  s: 'D4',
  e: 'D#4',
  d: 'E4',
  f: 'F4',
  t: 'F#4',
  g: 'G4',
  y: 'G#4',
  h: 'A4',
  u: 'A#4',
  j: 'B4',
  k: 'C5',
};

const Keyboard = ({musicData, resetMusicData}) => {
  const bpm = musicData.bpm
  const beatDuration = musicData.notes.reduce((acc, note) => acc + note.duration, 0)

  const synthRef = useRef(null);
  const metronomeRef = useRef(null)
  const activeKey = useRef(null);
  const metronomeEndTimeRef = useRef(null);

  const [noteEvents, _] = useState([])

  const [results, setResults] = useState(null)

  const start = async () => {
    await Tone.start();

    metronomeRef.current = new Tone.NoiseSynth({
      noise: { type: "white" },
      envelope: {
        attack: 0.001,
        decay: 0.05,
        sustain: 0,
      },
    }).toDestination();

    const secondsPerBeat = 60 / bpm;
    const baseTime = Tone.now();

    for (let i = 0; i < 4; i++) {
      const time = baseTime + i * secondsPerBeat;
      metronomeRef.current.triggerAttackRelease("8n", time);
    }

    metronomeEndTimeRef.current = baseTime + 4 * secondsPerBeat;

    setTimeout(async () => {
      // First make sure the user has a key released event as their last event
      if (noteEvents[noteEvents.length - 1]["event"] !== "released") {
        // Edge case: the user did not lift up their key on end. Add a released event
        const now = Tone.now();
        const diffMs = (now - metronomeEndTimeRef.current) * 1000;
        noteEvents.push({"note": noteEvents[noteEvents.length - 1]["note"], "event": "released", "ms": Math.round(diffMs)})
      }

      const res = await fetch(`${baseUrl}/record-session`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({"user_cookie_id": localStorage.getItem('userCookieID'), "music_data": musicData, "note_events": noteEvents}),
      })
      const status = await res.json()
      setResults(status)
    }, (beatDuration + 5) * (60 / bpm) * 1000);
  }

  useEffect(() => {
    synthRef.current = new Tone.Synth().toDestination();

    const handleKeyDown = async (e) => {
      const key = e.key.toLowerCase();
      const note = KEY_NOTE_MAP[key];

      if (note && activeKey.current !== key) {
        const now = Tone.now();

        if (metronomeEndTimeRef.current) {
          const diffMs = (now - metronomeEndTimeRef.current) * 1000;
          noteEvents.push({"note": note, "event": "pressed", "ms": Math.round(diffMs)})
        }

        // If another key is active, release its note
        if (activeKey.current) {
          synthRef.current.triggerRelease();
        }

        // Play the new note
        synthRef.current.triggerAttack(note);
        activeKey.current = key;
      }
    };

    const handleKeyUp = (e) => {
      const now = Tone.now();
      const key = e.key.toLowerCase();

      if (metronomeEndTimeRef.current) {
        const diffMs = (now - metronomeEndTimeRef.current) * 1000;
        noteEvents.push({"note": KEY_NOTE_MAP[key], "event": "released", "ms": Math.round(diffMs)})
      }

      if (activeKey.current === key) {
        synthRef.current.triggerRelease();
        activeKey.current = null;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, []);


  return (
    <div>
      {(!!results) ? 
      <div>
        {/*<p onClick={() => resetMusicData()} style={{display: 'inline-block', border: '1px solid black', padding: '4px', cursor: 'pointer'}}>Next Challenge</p>*/}
        <p><b>Please REFRESH your browser for the next challenge</b></p>
        <p>Accuracy: {results.accuracy * 100}%</p>
        {results.log.map(l => (
          <p>At time {l.time_point} ms | Expected: {(l.expected_note) ? l.expected_note : 'rest'}, Played: {(l.played) ? l.played: 'rest'}</p>
        ))}
      </div> 
      :
      <div>
        <p onClick={() => start()} style={{display: 'inline-block', border: '1px solid black', padding: '4px', cursor: 'pointer'}}>Start Challenge</p>
        <p> Key Reference:</p>
        <KeyboardExample />
      </div>}
    </div>
  );
};

export default Keyboard;